import type { ExtendedDate } from '~/utils/ExtendedDate'

type CalendarMonth = {
  year: number
  month: number
  days: ExtendedDate[]
  daysBefore: ExtendedDate[]
}

export function makeCalendar (date: ExtendedDate, numberOfMonths: number): CalendarMonth[] {
  const startDate = date.getFirstDayOfMonth()
  const daysOfMonth = (monthDate: ExtendedDate): ExtendedDate[] => {
    const days: ExtendedDate[] = []
    for (let i = 0; i < monthDate.getMonthDays(); i++) {
      days.push(monthDate.addDays(i))
    }
    return days
  }

  const daysOfMonthBefore = (monthDate: ExtendedDate): ExtendedDate[] => {
    const firstWeekday = monthDate.getRealWeekday()
    const days: ExtendedDate[] = []
    for (let i = 1 - firstWeekday; i < 0; i++) {
      days.push(monthDate.addDays(i))
    }
    return days
  }

  const months: CalendarMonth[] = []
  for (let i = 0; i < numberOfMonths; i++) {
    const monthDate = startDate.addMonths(i)
    months.push({
      year: monthDate.getFullYear(),
      month: monthDate.getMonth() + 1,
      days: daysOfMonth(monthDate),
      daysBefore: daysOfMonthBefore(monthDate)
    })
  }
  return months
}
